"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
class GetDefaultPropositionsResponseProductDetailsFitTariffs extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    (0, base_models_1.Docs)({ example: 0.038, description: 'Single meter feed-in rate.' }),
    tslib_1.__metadata("design:type", Number)
], GetDefaultPropositionsResponseProductDetailsFitTariffs.prototype, "fitStandardRate", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    (0, base_models_1.Docs)({ example: 0.0415, description: 'Double meter peak feed-in rate.' }),
    tslib_1.__metadata("design:type", Number)
], GetDefaultPropositionsResponseProductDetailsFitTariffs.prototype, "fitPeakRate", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    (0, base_models_1.Docs)({ example: 0.0315, description: 'Double meter off-peak feed-in rate.' }),
    tslib_1.__metadata("design:type", Number)
], GetDefaultPropositionsResponseProductDetailsFitTariffs.prototype, "fitOffPeakRate", void 0);
tslib_1.__decorate([
    (0, base_models_1.IsNullable)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    (0, base_models_1.Docs)({ example: 2200, description: '(kWh) Upper limit for the feed-in rates. When multiple feed-in rates are are provided, all but the last require this limit. If the last item has a limit, no compensation is provided beyond that limit.' }),
    tslib_1.__metadata("design:type", Object)
], GetDefaultPropositionsResponseProductDetailsFitTariffs.prototype, "fitLimit", void 0);
exports.default = GetDefaultPropositionsResponseProductDetailsFitTariffs;
